export default {
    regSeason: {
        standings: [
            {
                manager: 'Conor',
                wins: 11,
                losses: 2,
                pf: 2131.36
            },
            {
                manager: 'Kieffer',
                wins: 11,
                losses: 2,
                pf: 2084.84
            },
            {
                manager: 'Dan',
                wins: 9,
                losses: 4,
                champ: true,
                pf: 2068.08
            },
            {
                manager: 'Taylor',
                wins: 8,
                losses: 5,
                pf: 1833.38
            },
            {
                manager: 'Aidan',
                wins: 8,
                losses: 5,
                pf: 1852.96
            },
            {
                manager: 'Davis',
                wins: 7,
                losses: 6,
                pf: 1659.12
            },
            {
                manager: 'Mike',
                wins: 7,
                losses: 6,
                pf: 1634.80
            },
            {
                manager: 'Steve',
                wins: 5,
                losses: 8,
                pf: 1563.74
            },
            {
                manager: 'Tommy',
                wins: 4,
                losses: 9,
                pf: 1574.60
            },
            {
                manager: 'Scott',
                wins: 4,
                losses: 9,
                pf: 1724.88,
                sacko: true
            },
            {
                manager: 'Tench',
                wins: 3,
                losses: 10,
                pf: 1471.34
            },
            {
                manager: 'Zane',
                wins: 1,
                losses: 12,
                pf: 1190.88
            }
        ]
    },
    playoffs: {
        teamData: {
            Conor: {
                seed: 1
            },
            Dan: {
                seed: 2
            },
            Kieffer: {
                seed: 3
            },
            Taylor: {
                seed: 4
            },
            Aidan: {
                seed: 5
            },
            Davis: {
                seed: 6
            }
        },
        gameData: [
            {
                name: 'Caleci-Fairlawn-Kennedy Championship Game',
                games: [
                    {
                        Dan: 231.74,
                        Taylor: 144.24
                    }
                ],
                props: {
                    winnerIcon: 'trophyGold bi bi-trophy-fill',
                    loserIcon: 'trophySilver bi bi-trophy-fill',
                }
            },
            {
                name: 'Thomas McGrath Award',
                games: [
                    {
                        Conor: 186.7,
                        Kieffer: 187.52
                    }
                ],
                props: {
                    winnerIcon: 'trophyBronze bi bi-trophy-fill',
                }
            },
            {
                name: 'Semifinals',
                games: [
                    {
                        Dan: 165.82,
                        Kieffer: 161.46
                    },
                    {
                        Conor: 133.04,
                        Taylor: 146.20
                    }
                ]
            },
            {
                name: 'Wildcard',
                games: [
                    {
                        Davis: 134.2,
                        Kieffer: 177.62
                    },
                    {
                        Aidan: 66.54,
                        Taylor: 108.68
                    }
                ]
            },
        ]
    },
    draft: {
        order: [
            'Mike',	
            'Dan', 	
            'Kieffer',	
            'Conor',	
            'Zane',	
            'Davis',
            'Tommy',	
            'Aidan',	
            'Steve',	
            'Scott',	
            'Tench',	
            'Taylor' 	
        ],
        picks: [
            {manager: 'Conor', pick: 'Davante Adams, GB'},
            {manager: 'Dan', pick: 'Alvin Kamara, NO'},
            {manager: 'Kieffer', pick: 'Patrick Mahomes, KC'},
            {manager: 'Conor', pick: 'Travis Kelce, KC'},
            {manager: 'Kieffer', pick: 'Dalvin Cook, Min'},
            {manager: 'Mike', pick: 'Tyreek Hill, KC'},
            {manager: 'Mike', pick: 'Clyde Edwards-Helaire, KC'},
            {manager: 'Zane', pick: 'Odell Beckham Jr., Cle'},
            {manager: 'Davis', pick: 'Todd Gurley II, Atl'},
            {manager: 'Conor', pick: 'Austin Ekeler, LAC'},
            {manager: 'Tench', pick: 'Cam Akers, LAR'},
            {manager: 'Dan', pick: 'Keenan Allen, LAC'},
            {manager: 'Tench', pick: 'J.K. Dobbins, Bal'},
            {manager: 'Dan', pick: 'Chris Carson, Sea'},
            {manager: 'Kieffer', pick: 'Adam Thielen, Min'},
            {manager: 'Scott', pick: 'Raheem Mostert, SF'},
            {manager: 'Taylor', pick: 'Antonio Gibson, Wsh'},
            {manager: 'Davis', pick: 'Jonathan Taylor, Ind'},
            {manager: 'Scott', pick: 'James Conner, Pit'},
            {manager: 'Tench', pick: 'D\'Andre Swift, Det'},
            {manager: 'Tench', pick: 'Tyler Boyd, Cin'},
            {manager: 'Aidan', pick: 'Will Fuller V, Hou'},
            {manager: 'Zane', pick: 'Henry Ruggs III, LV'},
            {manager: 'Tench', pick: 'Evan Engram, NYG'},
            {manager: 'Davis', pick: 'Jerry Jeudy, Den'},
            {manager: 'Davis', pick: 'CeeDee Lamb, Dal'},
            {manager: 'Kieffer', pick: 'Zach Ertz, Phi'},
            {manager: 'Scott', pick: 'Jarvis Landry, Cle'},
            {manager: 'Dan', pick: 'Stefon Diggs, Buf'},
            {manager: 'Dan', pick: 'Allen Robinson II, Chi'},
            {manager: 'Taylor', pick: 'Bryan Edawrds, LV'},
            {manager: 'Steve', pick: 'Dak Prescott, Dal'},
            {manager: 'Steve', pick: 'Julian Edelman, NE'},
            {manager: 'Steve', pick: 'Michael Pittman Jr., Ind'},
            {manager: 'Davis', pick: 'T.Y. Hilton, Ind'},
            {manager: 'Aidan', pick: 'Deshaun Watson, Hou'},
            {manager: 'Conor', pick: 'Russell Wilson, Sea'},
            {manager: 'Scott', pick: 'Tee Higgins, Cin'},
            {manager: 'Kieffer', pick: 'Justin Jefferson, Min'},
            {manager: 'Conor', pick: 'Jalen Reagor, Phi'},
            {manager: 'Aidan', pick: 'Diontae Johnson, Pit'},
            {manager: 'Aidan', pick: 'Brandon Aiyuk, SF'},
            {manager: 'Tommy', pick: 'Sterling Shepard, NYG'},
            {manager: 'Taylor', pick: 'Joe Burrow, Cin'},
            {manager: 'Steve', pick: 'Darius Slayton, NYG'},
            {manager: 'Tommy', pick: 'Jamison Crowder, NYJ'},
            {manager: 'Tommy', pick: 'Zack Moss, Buf'},
            {manager: 'Taylor', pick: 'Chris Thompson, Jax'},
            {manager: 'Davis', pick: 'Tony Pollard, Dal'},
            {manager: 'Dan', pick: 'Emmanuel Sanders, NO'},
            {manager: 'Kieffer', pick: 'Golden Tate, NYG'},
            {manager: 'Conor', pick: 'Hunter Henry, LAC'},
            {manager: 'Zane', pick: 'Alshon Jeffery, Phi'},
            {manager: 'Tommy', pick: 'Tyler Higbee, LAR'},
            {manager: 'Tommy', pick: 'Tom Brady, TB'},
            {manager: 'Davis', pick: 'Carson Wentz, Phi'},
            {manager: 'Aidan', pick: 'Hayden Hurst, Atl'},
            {manager: 'Aidan', pick: '49ers D/ST, SF'},
            {manager: 'Mike', pick: 'Anthony Miller, Chi'},
            {manager: 'Taylor', pick: 'Marvin Jones Jr Det'},
            {manager: 'Alex', pick: 'Matthew Stafford, Det'},
            {manager: 'Dan', pick: 'Aaron Rodgers, GB'},
            {manager: 'Kieffer', pick: 'AJ Dillon, GB'},
            {manager: 'Conor', pick: 'Steelers D/ST, Pit'},
            {manager: 'Zane', pick: 'Sammy Watkins, KC'},
            {manager: 'Davis', pick: 'Justin Tucker, Bal'},
            {manager: 'Tommy', pick: 'Boston Scott, Phi'},
            {manager: 'Aidan', pick: 'Harrison Butker, KC'},
            {manager: 'Steve', pick: 'Joshua Kelley, LAC'},
            {manager: 'Taylor', pick: 'Blake Jarwin, Dal'},
            {manager: 'Dan', pick: 'Larry Fitzgerald, Ari'},
            {manager: 'Taylor', pick: 'Justin Jackson, LAC'},
            {manager: 'Mike', pick: 'John Brown, Buf'},
            {manager: 'Dan', pick: 'Ravens D/ST, Bal'},
            {manager: 'Kieffer', pick: 'Greg Zuerlein, Dal'},
            {manager: 'Conor', pick: 'Wil Lutz, NO'},
            {manager: 'Zane', pick: 'Adrian Peterson, Det'},
            {manager: 'Davis', pick: 'Bills D/ST, Buf'},
            {manager: 'Tommy', pick: 'Patriots D/ST, NE'},
            {manager: 'Talylor', pick: 'Malcolm Brown, LAR'},
            {manager: 'Davis', pick: 'Tua Tua, Mia'},
            {manager: 'Scott', pick: 'Damien Harris, NE'},
            {manager: 'Tench', pick: 'Mike Gesicki, Mia'},
            {manager: 'Taylor', pick: 'Kenny Stills, Hou'},
        ]
    }
}